type BuyerLeadCohortRecord = {
  userId: string;
  firstSuccessfulViewingDate: string | null;
};

type OfferCohortRecord = {
  buyerId: string;
  madeOn: string;
};

export const computeBuyerFunnelMetrics = (
  buyerLeads: readonly BuyerLeadCohortRecord[],
  offers: readonly OfferCohortRecord[],
  asOfDate: string,
) => {
  const buyerIds = new Set<string>();
  const firstViewingByBuyer = new Map<string, string>();

  for (const buyerLead of buyerLeads) {
    buyerIds.add(buyerLead.userId);

    const viewingDate = buyerLead.firstSuccessfulViewingDate;
    if (viewingDate == null || viewingDate > asOfDate) {
      continue;
    }

    const previousDate = firstViewingByBuyer.get(buyerLead.userId);
    if (previousDate == null || viewingDate < previousDate) {
      firstViewingByBuyer.set(buyerLead.userId, viewingDate);
    }
  }

  const buyersWithOffers = new Set<string>();
  for (const offer of offers) {
    const firstViewingDate = firstViewingByBuyer.get(offer.buyerId);
    if (
      firstViewingDate != null &&
      offer.madeOn >= firstViewingDate &&
      offer.madeOn <= asOfDate
    ) {
      buyersWithOffers.add(offer.buyerId);
    }
  }

  return {
    buyerLeads: buyerIds.size,
    viewedBuyers: firstViewingByBuyer.size,
    buyersWithOffers: buyersWithOffers.size,
    viewedBuyerDates: [...firstViewingByBuyer.values()],
  };
};
